import { fetchQuery } from '../utils/data/graphql';
import { seoFragment } from './seo';

export const eventByURIQuery = `query($uri: ID!) {
  event(id: $uri, idType: SLUG){
    id
    title
    date
    content
    ${seoFragment}
    eventSponsorship {
      banner {
        mediaItemUrl
      }
    }
    eventDetails {
      eventCost
      eventStartDate
      eventStartTime
      eventLocation
      eventCityCountry
      eventEndDate
      eventEndTime
      url
    }
    articleImage {
      thumbnail {
        mediaItemUrl
      }
    }
  }
}`;

export const technicalSessionsQueryForward = `query events($endCursor: String, $startCursor: String) {
  events(where: {eventType: "technical"}, first: 5, after: $endCursor, before: $startCursor) {
    nodes {
      id
      title
      slug
      eventDetails {
        eventCost
        eventStartDate
        eventLocation
        eventCityCountry
        eventEndDate
      }
      articleExcerpt {
        excerpt
      }
      articleImage {
        thumbnail {
          mediaItemUrl
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
`;

export const technicalSessionsQueryBack = technicalSessionsQueryForward.replace(
  'first: 10',
  'last: 10'
);

export const fetchTechnicalSessions = async (
  endCursor?: string,
  startCursor?: string
) => {
  const query = startCursor
    ? technicalSessionsQueryBack
    : technicalSessionsQueryForward;

  const res = await fetchQuery(query, {
    endCursor,
    startCursor
  });

  return res.data;
};

export const fetchEventByURI = async (uri: string) => {
  const res = await fetchQuery(eventByURIQuery, {
    uri: uri
  });
  return res.data;
};
